import {documentToPlainTextString} from '@contentful/rich-text-plain-text-renderer'
import {Box, Card, Grid} from '@primer/react-brand/esm'
import {getImageSources, MAX_CONTENT_WIDTH} from '@github-ui/swp-core/lib/utils/images'
import {renderWithoutParagraphs} from '../../../../utils'
import type {IntroSectionProps} from '../types'

type Props = Pick<IntroSectionProps, 'introImageCards'> & {promoteFirstHeading?: boolean}

export function IntroImageCards({introImageCards, promoteFirstHeading = false}: Props) {
  if (!introImageCards || introImageCards.length === 0) return null

  const largeColumnSpan = introImageCards.length === 2 ? 6 : 4
  const imageMaxWidth = (MAX_CONTENT_WIDTH * largeColumnSpan) / 12

  return (
    <Box marginBlockStart={48}>
      <Grid>
        {introImageCards.map((card, index) => (
          <Grid.Column key={card.sys.id} span={{xsmall: 12, medium: 6, large: largeColumnSpan}}>
            <Card href={card.fields.href} variant="minimal" fullWidth ctaText={card.fields.label}>
              <Card.Image
                src={`${card.fields.image.fields.file.url}?fm=webp`}
                alt={card.fields.image.fields.description || documentToPlainTextString(card.fields.heading) || ''}
                sources={getImageSources(card.fields.image.fields.file.url, {
                  maxWidth: imageMaxWidth,
                })}
              />
              <Card.Heading as={index === 0 && promoteFirstHeading ? 'h2' : 'h3'} size="6">
                {renderWithoutParagraphs(card.fields.heading)}
                {card.fields.alt ? <span className="sr-only"> {card.fields.alt}</span> : null}
              </Card.Heading>
              <Card.Description>{renderWithoutParagraphs(card.fields.description)}</Card.Description>
            </Card>
          </Grid.Column>
        ))}
      </Grid>
    </Box>
  )
}
